import { useEffect, useState } from "react";

export function useTheme(): "light" | "dark" {
	const [theme, setTheme] = useState<"light" | "dark">(
		document.documentElement.classList.contains("dark") ? "dark" : "light",
	);

	useEffect(() => {
		const getTheme = () =>
			document.documentElement.classList.contains("dark") ? "dark" : "light";
		const observer = new MutationObserver(() => {
			setTheme(getTheme());
		});
		observer.observe(document.documentElement, {
			attributes: true,
			attributeFilter: ["class"],
		});
		return () => observer.disconnect();
	}, []);

	return theme;
}
